var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZip = function SvgZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.727 2.364a2.363 2.363 0 0 0-2.364 2.363v14.545a2.364 2.364 0 0 0 2.364 2.364H7.88a.25.25 0 0 0 .25-.25v-.712a.25.25 0 0 0-.25-.25H6.727a1.151 1.151 0 0 1-1.152-1.152V4.727a1.152 1.152 0 0 1 1.152-1.151h6.84l4.857 4.858v10.838a1.152 1.152 0 0 1-1.152 1.152H16.13a.25.25 0 0 0-.25.25v.712c0 .138.112.25.25.25h1.142a2.363 2.363 0 0 0 2.364-2.364V8.183a.606.606 0 0 0-.177-.428L14.245 2.54a.606.606 0 0 0-.429-.177h-7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.739 16.5a1.86 1.86 0 0 0-1.86 1.86v2.466c0 .44.357.796.798.796h2.656c.44 0 .797-.356.797-.796v-2.467a1.86 1.86 0 0 0-1.86-1.859h-.531Zm0 1.594a.266.266 0 0 0-.266.265v1.67h1.063v-1.67a.266.266 0 0 0-.266-.265h-.531Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.968 5.25a1 1 0 0 0-1-1H10.3a1 1 0 0 0 0 2h.667a1 1 0 0 0 1-1ZM13.7 6.51a1 1 0 0 1 0 2h-.667a1 1 0 1 1 0-2h.667ZM11.968 9.77a1 1 0 0 0-1-1.001H10.3a1 1 0 0 0 0 2h.667a1 1 0 0 0 1-1ZM14.7 12.029a1 1 0 0 0-1-1h-.667a1 1 0 1 0 0 2h.667a1 1 0 0 0 1-1ZM11.968 14.288a1 1 0 0 0-1-1H10.3a1 1 0 0 0 0 2h.667a1 1 0 0 0 1-1Z"
  }))));
};
export default SvgZip;